"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="d9820130-c8c9-5a43-9fa1-f2632f3d0cc5")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.ClauseType = exports.EquityType = exports.PaymentType = exports.DealType = void 0;
var DealType;
(function (DealType) {
    DealType["UNKNOWN"] = "unknown";
    DealType["DIETARY_SUPPLEMENTS_WELLNESS"] = "Dietary Supplements & Wellness";
    DealType["BEAUTY_SKINCARE"] = "Beauty & Skincare";
    DealType["FASHION_APPAREL"] = "Fashion & Apparel";
    DealType["FOOD_BEVERAGE"] = "Food & Beverage";
    DealType["FITNESS_SPORTS"] = "Fitness & Sports";
    DealType["TECH_GADGETS"] = "Tech & Gadgets";
    DealType["FINANCE_INVESTING"] = "Finance & Investing";
    DealType["ONLINE_LEARNING_COURSES"] = "Online Learning & Courses";
    DealType["HOME_LIFESTYLE"] = "Home & Lifestyle";
    DealType["ENTERTAINMENT_STREAMING"] = "Entertainment & Streaming";
})(DealType || (exports.DealType = DealType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["FLAT_FEE"] = "Flat Fee";
    PaymentType["PERFORMANCE"] = "Performance";
    PaymentType["EQUITY"] = "Equity";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var EquityType;
(function (EquityType) {
    EquityType["OPTIONS"] = "Options";
    EquityType["RSUS"] = "RSUs";
    EquityType["COMMON_STOCK"] = "Common Stock";
})(EquityType || (exports.EquityType = EquityType = {}));
var ClauseType;
(function (ClauseType) {
    ClauseType["FTC_RISK"] = "FTC_RISK";
    ClauseType["INDEMNIFICATION"] = "INDEMNIFICATION";
    ClauseType["IP_ASSIGNMENT"] = "IP_ASSIGNMENT";
    ClauseType["CONFIDENTIALITY"] = "CONFIDENTIALITY";
})(ClauseType || (exports.ClauseType = ClauseType = {}));
//# sourceMappingURL=brand-deal.js.map
//# debugId=d9820130-c8c9-5a43-9fa1-f2632f3d0cc5
